<template>
    <div class="template template--basic">

        <div class="login">

            <header class="login__header" v-if="!requested">
                <h1>Hallo!</h1>
                <p>Vul je gegevens in om jouw eigen werkmap aan te maken.<br>
                <strong>Let op:</strong> je kunt alleen registreren met jouw uitnodigingscode.</p>
            </header>

            <header class="login__header" v-else>
                <h1>Gelukt!</h1>
                <p>Activeer eerst je account om verder te gaan.</p>
            </header>

            <div class="login__panel-wrap"  v-if="!requested">
                <div class="login__panel">

                    <form class="login__form">
                        <div class="input-group" :class="{ error : containsError('code')}">
                            <label for="code">Uitnodigingscode</label>
                            <input type="text" name="code" id="code" v-model="code" @keydown.enter.prevent="submit" :autofocus="!isTouch"  />
                        </div>

                        <div class="input-group" :class="{ error : containsError('email')}">
                            <label for="email">E-mail</label>
                            <input type="email" name="email" id="email" v-model="email" @keyup.enter.prevent="submit"  />
                        </div>

                        <!-- <div class="input-group" :class="{ error : containsError('terms')}">
                            <input type="checkbox" name="terms" id="terms" value="terms" v-model="terms"/><label for="terms">Ik ga akkoord met de <a href="#" @click.prevent="showTerms()">algemene voorwaarden</a> en <a href="#" @click.prevent="showPrivacy()">privacyverklaring</a>.</label><br>
                        </div> -->

                        <div v-if="forgot">
                            <router-link :to="{ name: 'forgot' }" class="to-forgot" >Wachtwoord vergeten?</router-link>
                        </div>

                        <primary-button :link="{ name: 'root' }" @clicked="submit" :loading="loading" >Registreren</primary-button>

                    </form>

                </div>


                <div class="login__auth-other">
                    Heb je al een werkmap? <router-link :to="{ name: 'login' }" class="to-login" >Log in</router-link>
                </div>

            </div>

            <div class="login__panel-wrap"  v-else>
                <div class="login__panel">

                    <p>Er is een mailtje verstuurd naar: <strong>{{ email }}</strong><p>
                    <p>Bekijk je mail en klik op de activatie knop om door te gaan.</p>
                    <p class="note note--info"><strong>Geen mailtje ontvangen?</strong> Check eerst je <em>spam</em> map, controleer of je je e-mailadres goed hebt ingevuld en <a href="#" class="to-register" @click="retry">probeer het opnieuw</a>.</p>

                </div>
            </div>

        </div>

    </div>
</template>


<script>
import api from 'js/api/resources'
import notify from 'js/components/notifications/notificationsMixin'
import validation from 'js/components/auth/validationMixin'
import touch from 'js/components/auth/touchMixin'
import track from 'js/helpers/analytics'

import PrimaryButton from 'js/components/elements/PrimaryButton.vue'

export default {
    name: 'Register',
    mixins: [ notify, validation, touch ],
    components: { PrimaryButton },
    props: [],

    data: function() {
        return {
            email: '',
            code: '',
            loading: false,
            requested: false,
            errors: [],
            errorFields: [],
            forgot: false,
            history: [],
            terms: false,
        }
    },

    vuex: {
        actions: {

            showTerms: ({ dispatch }) => {
                dispatch('SHOW_MODAL', 'legal', { type: 'terms', title: 'Algemene voorwaarden'})
            },

            showPrivacy: ({ dispatch }) => {
                dispatch('SHOW_MODAL', 'legal', { type: 'privacy', title: 'Privacyverklaring'})
            },

        }
    },

    methods: {

        submit: function(e) {

            e.preventDefault()

            if ( this.validate() && !this.throttled(this.email) ) {

                this.loading = true

                api.registrationRequest(this.email, this.code, this.terms)
                    .then( () => {
                        this.requested = true
                        this.throttleHit(this.email)
                    })
                    .catch( response => {
                        if ( response.status === 409 ) {
                            this.forgot = true
                            this.addFieldError('email')
                            this.$warn('Dit e-mailadres is al geregistreerd.')
                        } else {
                            this.handleErrorResponse(response, 'Registratie is mislukt.')
                        }
                    })
                    .then( () => this.loading = false )

            }

        },

        retry: function(e) {
            e.preventDefault()
            this.email = '',
            this.requested = false
        },

        validateFields: function() {
            this.validateCode(this.code)
            this.validateEmail(this.email)
            // this.validateTerms(this.terms)
        },

        throttled: function(email) {
            const previous = this.history[email]

            if ( previous == null ) {
                return false
            }

            if ( (Date.now() - previous.first) > 5*60*1000 ) {
                delete this.history[email]
                return false
            }

            this.$alert({ title: 'Al geregistreerd', message: 'Binnen enkele minuten ontvang je een activatiemail. Kijk ook bij "Ongewenste mail" (spam) en controleer of je "'+this.email+'" goed hebt gespeld.'}, [{ name: 'Oké'}])
            track.event('register', 'dupe', this.code.substr(0, 2).padEnd(5, '*'))

            return true

        },

        throttleHit: function(email) {
            this.history[email] = {
                first: Date.now(),
            }
        },


    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Register.vue?8b80f3be